import { render, staticRenderFns } from "./Addendum.vue?vue&type=template&id=37370ed6&scoped=true&"
import script from "./Addendum.vue?vue&type=script&lang=js&"
export * from "./Addendum.vue?vue&type=script&lang=js&"
import style0 from "./Addendum.vue?vue&type=style&index=0&id=37370ed6&prod&scoped=true&lang=css&"
import style1 from "./Addendum.vue?vue&type=style&index=1&id=37370ed6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37370ed6",
  null
  
)

export default component.exports